<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <CaseACocherLive code="decla1" v-model="sasInscriptionTableau.decla1" :live="liveSasInscriptionTableau(7720)" />
      <CaseACocherLive code="decla2" v-model="sasInscriptionTableau.decla2" :live="liveSasInscriptionTableau(7721)" />
      <CaseACocherLive code="decla3" v-model="sasInscriptionTableau.decla3" :live="liveSasInscriptionTableau(7722)" />
      <CaseACocherLive code="decla4" v-model="sasInscriptionTableau.decla4" :live="liveSasInscriptionTableau(7723)" />
      <CaseACocherLive code="decla5" v-model="sasInscriptionTableau.decla5" :live="liveSasInscriptionTableau(7724)" />
      <CaseACocherLive code="decla6" v-model="sasInscriptionTableau.decla6" :live="liveSasInscriptionTableau(7725)" />
    </v-form>
  </div>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasInscriptionTableau() {
      return this.sas.sasInscriptionTableau
    }
  },
  methods: {
    liveSasInscriptionTableau(cle) {
      return { endpoint: "sas-inscription-tableau", cle: cle, fileId: this.sasInscriptionTableau.id }
    }
  }
}
</script>

<style>
</style>